import { axiosApi } from "../../../api/dbAxios";

export const deleteTeam = async (id: number | string) => {
  try {
    const response = await axiosApi.delete(`/teams/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error deleting Team:", error);
    return [];
  }
};
